import _ from 'lodash';

/*
 * Constants.
 */

export const UNLIMITED_FEATURE_COUNT = 10000;

/*
 * Helpers.
 */

// Base features like "channels:10" and "channels:30" do not add up, we just pick the highest number
// However, you can also have additive features like "+channels:5" which add on top of the base number.
export function maxNumberOfFeatureType(type: string, features: ReadonlyArray<string>, defaultNum = 0) {
  const unlimitedType = `${type}:+`;
  const typeDefRe = () => new RegExp(`^${type}:(\\d+)$`);

  return _(features).reduce((m, feat) => {
    // "rules:+" or "rules" means nearly unlimited access.
    if (feat === unlimitedType) {
      return UNLIMITED_FEATURE_COUNT;
    }

    const res = typeDefRe().exec(feat);

    return res ? Math.max(Number(res[1]), m) : m;
  }, defaultNum);
}

export function isIntegrationUncounted(features: ReadonlyArray<string>, integrationId: string) {
  return features.includes(`int0:${integrationId}`);
}

export function hasFeature(feature: string, features: ReadonlyArray<string> | undefined) {
  return (features ?? []).some((f) => f === feature || f.startsWith(`${feature}:`));
}

export function isCustomPricingExpiring(renewalDate: number | null, licenses: any) {
  // Is the customer's current custom pricing is set to expire on or before the renewalDate?
  if (renewalDate && licenses?.config?.expiration) {
    return licenses.config.expiration <= renewalDate;
  }

  return false;
}

export function getRenewalDate(contractEndDate: number | undefined, subscriptionEndsAt: number | undefined) {
  // Determines display renewal date for banner/modal display.
  // Favors the ongoing contract commitment end date over the billing cycle end date.
  if (contractEndDate && contractEndDate > Date.now()) {
    return contractEndDate;
  }

  // subscription.ends_at is timestamp w/o ms
  if (subscriptionEndsAt) {
    return subscriptionEndsAt * 1000;
  }

  return null;
}
